import React from 'react';
import MUIDataTable from 'mui-datatables';
import PropTypes from 'prop-types';
// material
import { Box, Container, CircularProgress, Typography } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
// components
import Page from 'presentation/components/Page';
// local
import { theme } from 'presentation/theme';
import { makeStyles } from '@mui/styles';
import columns from './columns';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    }
}));

const tableTheme = createTheme(
    {
        overrides: {
            MUIDataTableHeadCell: {
                root: {
                    '&:nth-child(1)': {
                        width: '17vw'
                    },
                    '&:nth-child(2)': {
                        width: '17vw'
                    },
                    '&:nth-child(3)': {
                        width: '17vw'
                    },
                    '&:nth-child(4)': {
                        width: '17vw'
                    }
                }
            }
        }
    },
    theme
);

function InterventionListView(props) {
    const classes = useStyles();

    // get props
    const { interventions, rowsPerPageValue, loading, handleOnChangeRowsPerPage, handleCustomSort } = props;

    //  table options
    const options = {
        filterType: 'checkbox',
        rowsPerPage: rowsPerPageValue,
        rowsPerPageOptions: [5, 10, 15],
        responsive: 'simple', // responsive type
        resizableColumns: false,
        selectableRows: 'none',
        print: false,
        download: false,
        jumpToPage: true,
        textLabels: {
            body: {
                noMatch: loading ? <CircularProgress /> : 'Sorry, there is no matching data to display'
            }
        },
        onChangeRowsPerPage: handleOnChangeRowsPerPage,
        customSort: handleCustomSort
    };

    return (
        <Page className={classes.root} title="Interventions">
            <Container maxWidth={false}>
                <div>
                    <Box display="flex">
                        <Box flexGrow={1}>
                            <Typography color="textPrimary" variant="h2">
                                Interventions
                            </Typography>
                        </Box>
                    </Box>
                </div>
                <Box mt={3}>
                    <ThemeProvider theme={tableTheme}>
                        <MUIDataTable data={interventions} columns={columns} options={options} className={classes.table} />
                    </ThemeProvider>
                </Box>
            </Container>
        </Page>
    );
}

InterventionListView.propTypes = {
    // controller state variables
    interventions: PropTypes.array.isRequired,
    rowsPerPageValue: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired,
    // controller functions
    handleOnChangeRowsPerPage: PropTypes.func.isRequired,
    handleCustomSort: PropTypes.func.isRequired
};

export default InterventionListView;
